import { render } from "./ReportsPage.vue?vue&type=template&id=cc20dbb2&ts=true"
import script from "./ReportsPage.vue?vue&type=script&lang=ts"
export * from "./ReportsPage.vue?vue&type=script&lang=ts"

import "./ReportsPage.vue?vue&type=style&index=0&id=cc20dbb2&class=stylus&lang=css"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__